export default [
    {
        name: 'Regular (Left Forward)',
        value: 'regular'
    },
    {
        name: 'Goofy (Right Forward) ',
        value: 'goofy'
    }
]
